import { Avatar, AvatarProps } from '@mui/material';
import { ReactNode } from 'react';

export type AvatarIconProps = AvatarProps<
  'div',
  {
    icon: ReactNode | null | undefined;
  }
>;

export function AvatarIcon({ icon, ...props }: AvatarIconProps) {
  return <Avatar {...props}>{icon}</Avatar>;
}
